export default function createDimensionKey(dimension) {
	return `${dimension.group_by}_${dimension.grouping_field}`;
}
